import React, { useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { SurveyContext } from "../context/surveyContext";
import { SessionContext } from "../context/sessionContext";

export default function LinkedInCallback() {
  const hasRun = useRef(false);
  const navigate = useNavigate();
  const { surveyData, audienceData } = useContext(SurveyContext);
  const { socialLogin } = useContext(SessionContext);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    (async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      const returnedState = params.get("state");
      const storedState = localStorage.getItem("linkedin_csrf");

      if (returnedState !== storedState) {
        alert("Invalid state parameter. CSRF protection triggered!");
        sessionStorage.removeItem("pendingSignupFlow");
        navigate("/sign-up");
        return;
      }

      try {

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/linkedin`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              code,
              redirectUri: `${window.location.origin}/linkedin/callback`,
            }),
          }
        );

        const response = await res.json();

        if (!response.token) {
          console.error("LinkedIn authentication failed:", response);
          sessionStorage.removeItem("pendingSignupFlow");
          navigate("/sign-up");
          return;
        }


        const user = response.user || {
          email: response.email || response.data?.email,
          name: response.name || response.data?.name,
        };

        const loginResult = await socialLogin(response.token, user);
        if (!loginResult.success) {
          sessionStorage.removeItem("pendingSignupFlow");
          navigate("/sign-up");
          return;
        }

        let inviteData = null;
        const storedInviteData = localStorage.getItem("pendingInviteData");

        if (storedInviteData) {
          try {
            inviteData = JSON.parse(storedInviteData);
           
          } catch (e) {
           
          }
        }
        const isSignupFlow = localStorage.getItem("linkedin_signup_flow") === "true";
        const isNewUser = response.isNewUser === true;
        if (isSignupFlow || isNewUser || inviteData) {
          navigate("/create-org", {
            state: {
              isEmailSignup: false,
              socialToken: response.token,
              userName: user.name,
              inviteData: inviteData,
            },
          });
        } else {
          const role = response.role || response.user?.role;
          if (role === "superadmin") {
            navigate("/superadmin");
          } else {
            navigate("/projects");
          }
        }

        localStorage.removeItem("linkedin_signup_flow");
        localStorage.removeItem("linkedin_csrf");

      } catch (err) {
        console.error("LinkedIn auth error:", err);
        sessionStorage.removeItem("pendingSignupFlow");
        navigate("/sign-up");
      }
    })();
  }, [navigate, surveyData, audienceData, socialLogin]);

  return (
    <div className="page-bg" style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
    }}>
      <div style={{ textAlign: "center", color: "white" }}>
        <h3>Processing LinkedIn authentication...</h3>
        <p>Please wait while we set up your account.</p>
      </div>
    </div>
  );
}
